module.exports = __webpack_public_path__ + "assets/img/cube.e6298171.png";